var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case_box"},[_c('ul',_vm._l((_vm.inf),function(v,ind){return _c('li',{key:ind},[(v.flag)?_c('span',{staticClass:"btn_box",class:{'blue':v.url},on:{"click":function($event){_vm.tourl(v.url)}}},[_c('span',[_vm._v(_vm._s(v.url?v.data:'无'))])]):_c('span',[_vm._v("\n                "+_vm._s(v)+"\n            ")])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406a068e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/par/parheader.vue
// module id = null
// module chunks = 